"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "aviano": {
    "426169ca": [{
      "hkey": "96632c6c",
      "slug": "aviano",
      "name": "Aviano",
      "primary": true,
      "skipSearch": false
    }],
    "beorchia": [{
      "hkey": "96632c6c",
      "slug": "aviano",
      "name": "Aviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e9a40c2": [{
      "hkey": "c5bd6739",
      "slug": "castello-d-aviano",
      "name": "Castello d'Aviano",
      "primary": true,
      "skipSearch": false
    }],
    "castel-d-aviano": [{
      "hkey": "c5bd6739",
      "slug": "castello-d-aviano",
      "name": "Castello d'Aviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2b3dd627": [{
      "hkey": "96632c6c",
      "slug": "aviano",
      "name": "Aviano",
      "primary": true,
      "skipSearch": false
    }],
    "costa-ornedo": [{
      "hkey": "96632c6c",
      "slug": "aviano",
      "name": "Aviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "98062bbc": [{
      "hkey": "4b4bc9c7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pedemonte": [{
      "hkey": "4b4bc9c7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "aviano"
    }],
    "31b6abeb": [{
      "hkey": "96632c6c",
      "slug": "aviano",
      "name": "Aviano",
      "primary": true,
      "skipSearch": false
    }],
    "selva": [{
      "hkey": "96632c6c",
      "slug": "aviano",
      "name": "Aviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43392858": [{
      "hkey": "4b4bc9c7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "somprado": [{
      "hkey": "4b4bc9c7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "aviano"
    }]
  }
};
exports["default"] = _default;